module.exports = __webpack_public_path__ + "assets/e08f350a8b5da8ad339f6ca4f69c0219.png";